import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { IconArrowRight16, IconArrowLeft16 } from '@cian/ui-kit';

export interface IPaginationWrapperProps {
  disabled?: boolean;

  onPrev?(): void;

  onNext?(): void;
}

export const PaginationWrapper: React.FC<IPaginationWrapperProps & React.PropsWithChildren> = ({
  children,
  disabled,
  onNext,
  onPrev,
}) => (
  <div className={cn(styles['wrapper'], { [styles['disabled']]: disabled })}>
    <div className={styles['navigation']} onClick={onPrev} data-testid="pagination-prev">
      <IconArrowLeft16 color="primary_100" />
    </div>
    <div className={styles['items']}>{children}</div>
    <div className={styles['navigation']} onClick={onNext} data-testid="pagination-next">
      <IconArrowRight16 color="primary_100" />
    </div>
  </div>
);

PaginationWrapper.displayName = 'PaginationWrapper';
